<script>
	import { navigate } from 'svelte-routing';
  import { _ } from 'svelte-i18n';

  import questionnaire from './../libs/questionnaire.json';
  import { i18n } from './../libs/lang.js';
  import { answers } from './../libs/stores.js';
  import { maskQuestionnaire, toConfig } from './../libs/utils.js';
  
  import Footer from "./../components/Footer.svelte";

  let whattoshow = 'agency';
  let config, questions;
  
  let config_dict = {
    'agency':       [true, true, true, true, true, false],
    'accomodation': [true, true, true, true, false, false],
    'organizer':    [true, true, false, false, true, false],
    'public':       [true, true, false, false, true, true]
  }

  $: {
    config = toConfig(config_dict[whattoshow])

    questions = maskQuestionnaire(questionnaire, config)
      .map(section => section.questions)
      .flat()
  }    

  function handle_start(ev) {
    $answers.kind = whattoshow
    navigate("/p/" + config)
  }

  function handle_set_language(lang_id) {
    return (ev) => {
      i18n.language = lang_id
      location.reload()
    }
  }
</script>

<div>

  <div class="hero min-h-screen" style="background-image: url('/assets/bg_onat.svg');">
    <!-- lang -->
    <div class="absolute top-0 right-0 text-xl underline-offset-4 z-50">
      <span class="p-2 cursor-pointer" class:underline={i18n.language == "en"} on:click={handle_set_language("en")}>EN 🇬🇧️</span>
      <span class="p-2 cursor-pointer" class:underline={i18n.language == "it"} on:click={handle_set_language("it")}>IT 🇮🇹️</span>
      <span class="p-2 cursor-pointer" class:underline={i18n.language == "fr"} on:click={handle_set_language("fr")}>FR 🇫🇷️</span>
      <span class="p-2 cursor-pointer" class:underline={i18n.language == "es"} on:click={handle_set_language("es")}>ES 🇪🇸️</span>
    </div>

    <div class="hero-content text-center">
      <div class="max-w-md">
        <div class="my-8">
          <img class="mx-auto" src="/assets/icon.png">
          <h1 class="text-5xl font-bold">ONAT4All</h1>
          <p class="py-6"> {$_('home.subtitle')} </p>
        </div>

        <h3><b>{$_('home.start')}</b>: {$_('home.are_you')}</h3>

        <div class="my-4 text-left">
          <div class="form-control">
            <label class="label cursor-pointer">
              <span class="label-text"> {$_('home.agency')} </span>
              <input type="radio" class="radio radio-primary checked:bg-primary" value="agency" bind:group={whattoshow}/>
            </label>
          </div>
          <div class="form-control">
            <label class="label cursor-pointer">
              <span class="label-text"> {$_('home.accomodation')} </span>
              <input type="radio" class="radio radio-primary checked:bg-primary" value="accomodation" bind:group={whattoshow} />
            </label>
          </div>
          <div class="form-control">
            <label class="label cursor-pointer">
              <span class="label-text"> {$_('home.organizer')} </span>
              <input type="radio" class="radio radio-primary checked:bg-primary" value="organizer" bind:group={whattoshow} />
            </label>
          </div>
          <div class="form-control">
            <label class="label cursor-pointer">
              <span class="label-text"> {$_('home.public')} </span>
              <input type="radio" class="radio radio-primary checked:bg-primary" value="public" bind:group={whattoshow} />
            </label>
          </div>
        </div>

        <button class="btn btn-primary" on:click={handle_start}> {$_('home.get_started')} </button>
      </div>
    </div>
  </div>

  <!-- Modal dialog -->
  <input type="checkbox" id="modal_welcome" class="modal-toggle" checked />
  <div class="modal">
    <div class="modal-box w-11/12 max-w-5xl">
      <h3 class="font-bold text-lg"> {$_('home.popup_content_1')} </h3>
      <p class="py-4"> {$_('home.popup_content_2')} </p>
      <p class="py-4"> {$_('home.popup_content_3')} </p>
      <p class="py-4"> {$_('home.popup_content_4')} </p>
      <div class="modal-action justify-center">
        <label for="modal_welcome" class="btn btn-primary btn-wide"> {$_('home.ok')} </label>
      </div>
    </div>
  </div>

  <Footer/>
</div>

